import { LoaderCircle } from "lucide-react";

function Loader() {
  return (
    <div className="absolute top-0 left-0 flex items-center justify-center h-full w-full bg-white/50 z-50 backdrop-blur-px">
      <LoaderCircle
        className="size-8 animate-spin text-primary"
        strokeWidth={3}
      />
    </div>
  );
}

export default Loader;
